module.exports = __webpack_public_path__ + "img/Frame 5122.3def44c9.jpg";